import React from 'react';
import { FadeUp } from '../FadeUp';
import { GuaranteeAccordion } from '../GuaranteeAccordion';
export function Guarantee() {
  return <section className="px-5 pb-6" data-id="element-143" data-mp="20m4obp53y8tf">
      <div className="mx-auto w-full max-w-[620px]" data-id="element-144" data-mp="24n87olmd6mze">
        <FadeUp data-id="element-145" data-mp="24mey7cw0tjdk">
          <GuaranteeAccordion data-id="element-146" data-mp="24lwzm9lvyt2h" />
        </FadeUp>
      </div>
    </section>;
}